var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3C20.6569 3 22 4.34315 22 6V20C22 20.5523 21.5523 21 21 21C20.4477 21 20 20.5523 20 20V6C20 5.44772 19.5523 5 19 5H17C16.4477 5 16 5.44772 16 6V20C16 20.5523 15.5523 21 15 21C14.4477 21 14 20.5523 14 20V11C14 10.4477 13.5523 10 13 10H11C10.4477 10 10 10.4477 10 11V20C10 20.5523 9.55228 21 9 21C8.44772 21 8 20.5523 8 20V16C8 15.4477 7.55228 15 7 15H5C4.44772 15 4 15.4477 4 16V20C4 20.5523 3.55228 21 3 21C2.44772 21 2 20.5523 2 20V16C2 14.3431 3.34315 13 5 13H7C7.351 13 7.68694 13.0631 8 13.1738V11C8 9.34315 9.34315 8 11 8H13C13.351 8 13.6869 8.06306 14 8.17383V6C14 4.34315 15.3431 3 17 3H19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.3f90ab0a11d45f0db0c5f1cac4672860.svg";
export { ForwardRef as ReactComponent };